const END_OF_SENTENCE_PUNCTUATION = /([?!.,:-])$/;

const hasEndPunctuation = (text: string) => END_OF_SENTENCE_PUNCTUATION.test(text);

export default hasEndPunctuation;
